import { render, staticRenderFns } from "./ProfileSettingsForms.vue?vue&type=template&id=b0b183e4&"
import script from "./ProfileSettingsForms.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingsForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports